import { Navigate, Route, Routes } from 'react-router-dom'
import Configure from '../../../Pages/Study/ConfigureStudy/Configure'
import DataEntry from '../../../Pages/Study/DataEntry/DataEntry'
import CompleteEntry from '../../../Pages/Study/DataEntry/CompleteEntry'
import DataExport from '../../../Pages/Study/DataEntry/StudyExport'
import * as React from 'react'
import SelectResume from '../../../Pages/Study/DataEntry/SelectResume'
import SelectAnimals from '../../../Pages/Study/DataEntry/SelectAnimals'

function SelectedStudyRouter() {
  return (
    <Routes>
      <Route
        index
        element={
          <Navigate
            to={'configure'}
            replace
          />
        }
      />
      <Route
        path="configure"
        element={<Configure />}
      />
      <Route path="entry">
        <Route
          index
          element={
            <Navigate
              to={'select'}
              replace
            />
          }
        />
        <Route
          path="select"
          element={<SelectAnimals />}
        />
        <Route
          path="select/resume"
          element={<SelectResume />}
        />
        <Route
          path="sheet"
          element={<DataEntry />}
        />
        <Route
          path="complete"
          element={<CompleteEntry />}
        />
      </Route>
      <Route
        path="export"
        element={<DataExport />}
      />
    </Routes>
  )
}

export default SelectedStudyRouter
